// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__SdJxr","author":"Table_author__QDzkP","authorImage":"Table_authorImage__3EMYu","unreadRow":"Table_unreadRow__2kzaP"};